<template>
<div class="wrapper">
  <cabecalho tituloPagina="Agenda" />
  <menuLateral />

  <div class="content-wrapper">
    <section class="content-header">
      <div class="container-fluid">
        <div class="row mb-2">
          <div class="col-sm-6">
            <b-button class="botoes" variant="outline-primary btn-sm" @click="incluirEvento()" :disabled="flagsDeControle.carregandoDados.status">Incluir</b-button>
            <b-button class="botoes ml-2" variant="outline-primary btn-sm" @click="voltarCalendario()" :disabled="flagsDeControle.carregandoDados.status">Calendário</b-button>
            <b-button class="botoes ml-2" variant="outline-primary btn-sm" @click="redirecionarParaListagemConvites()" :disabled="flagsDeControle.carregandoDados.status">Convites</b-button>
          </div>
        </div>
      </div>
    </section>
    <section class="content">
      <div class="card">
        <div class="card-body">
          <div v-if="flagsDeControle.carregandoDados.status" class="d-flex align-items-center">
            <span class="avisoDanger">{{flagsDeControle.carregandoDados.mensagem}}</span>
            <b-spinner class="ml-2" variant="danger"></b-spinner>
          </div>
          <div class="card bg-light d-flex flex-fill">
            <div class="card-header border-bottom-0">
              <form v-on:keyup.enter="buscarRegistros()">
                <div class="form-row">
                  <div class="form-group col-md-12">
                    <b-form-group label="Evento" label-for="eventoFiltro" label-align-sm="left" label-size="sm" class="mb-0"></b-form-group>
                    <b-form-input id="evento" v-model="camposFiltroPesquisa.nomeEvento" type="text" :disabled="flagsDeControle.carregandoDados.status"></b-form-input>
                  </div>
                  <div class="form-group col-6 col-sm-6 col-md-6 col-xl-3">
                    <b-form-group label="Data Início" label-for="dataInicioFiltro" label-align-sm="left" label-size="sm" class="mb-0"></b-form-group>
                    <Datefield v-model="camposFiltroPesquisa.dataInicio" :classField="'form-control'" :disabled="flagsDeControle.carregandoDados.status" id="inputDataInicio"/>
                    <div class="avisoDanger text-left mt-1">{{dadosRetorno.listaDeErros.dataInicio}}</div>
                  </div>
                  <div class="form-group col-6 col-sm-6 col-md-6 col-xl-3">
                    <Timefield v-model="camposFiltroPesquisa.horaInicio" :classField="'form-control altura-botaoHora-pesquisa'" :disabled="flagsDeControle.carregandoDados.status" />
                    <div class="avisoDanger text-left mt-1">{{dadosRetorno.listaDeErros.horaInicio}}</div>
                  </div>
                  <div class="form-group col-6 col-sm-6 col-md-6 col-xl-3">
                    <b-form-group label="Data Término" label-for="dataTerminoFiltro" label-align-sm="left" label-size="sm" class="mb-0"></b-form-group>
                    <Datefield v-model="camposFiltroPesquisa.dataTermino" :classField="'form-control'" :disabled="flagsDeControle.carregandoDados.status" id="inputDataTermino"/>
                    <div class="avisoDanger text-left mt-1">{{dadosRetorno.listaDeErros.dataTermino}}</div>
                  </div>
                  <div class="form-group col-6 col-sm-4 col-md-3 col-xl-2">
                    <Timefield v-model="camposFiltroPesquisa.horaTermino" :classField="'form-control altura-botaoHora-pesquisa'" :disabled="flagsDeControle.carregandoDados.status" />
                    <div class="avisoDanger text-left mt-1">{{dadosRetorno.listaDeErros.horaTermino}}</div>
                  </div>
                  <div class="form-group col col-sm-2 col-md-3 col-xl-1 mt-5 text-right">
                    <b-button class="botoes" variant="outline-primary btn-sm" @click="buscarRegistros()" :disabled="flagsDeControle.carregandoDados.status">Buscar</b-button>
                  </div>
                </div>
              </form>
            </div>
          </div>
          <default-table
            :items="listaDeEventos"
            :fields="fields"
            :sort-by="componenteOrdenacao.campo"
            :sort-direction="componenteOrdenacao.sentido"
            :busy="flagsDeControle.carregandoDados.status"
            @sortChanged="ordenarLista"
            :tbody-tr-class="tabelaSemRegistros">
            <template #empty>
              <em>Nenhum registro encontrado.</em>
            </template>
            <template #cell(f_summary)="row">
              <a href="#" class="textos" variant="outline-primary btn-sm mt-2" @click="editarEvento(row.item.f_uuid)" :disabled="flagsDeControle.carregandoDados.status">{{ row.item.f_summary }}</a>
            </template>
          </default-table>
          <pagination :fonteDeDados="componentePaginacao.fonteDeDados" :disabled="flagsDeControle.carregandoDados.status" @navegarNaPaginacao="obterDadosPaginados"/>
        </div><!-- /.card-body -->
      </div><!-- /.card -->
    </section>
  </div>
</div>
</template>

<script>
import Eventos from './js'
export default Eventos
</script>

<style scoped>
@import "./scss/eventos.scss";
</style>
